import axios from 'axios';
import qs from 'query-string';
import { apiConfig } from '../api-config';

export interface ActAndAppoitmentGetAllParams {
  cdTerritory: string;
  tokenKey: string;
  agentId: string;
}

const validateStatus = (status: number) => (status >= 200 && status <= 300) || status === 404;

export const actAndAppoitmentGetAll = async ({
  agentId,
  cdTerritory,
  ...rest
}: ActAndAppoitmentGetAllParams) => {
  const queryAct = qs.stringify({
    ...rest,
    cdTerritory,
  });

  const queryAppointment = qs.stringify({
    territoryId: cdTerritory,
    agentId,
    ...rest,
  });

  const actGetAll = apiConfig.get(`/api/ActDocument/get-by-cdTerritory?${queryAct}`, {
    validateStatus,
  });

  const appointmentGetAll = apiConfig.get(
    `api/appointments/get-by-id-agent-id-territory?${queryAppointment}`,
    { validateStatus },
  );

  return axios.all([appointmentGetAll, actGetAll]).then(
    axios.spread((resp1, resp2) => ({
      data: [...(resp1.data.objectResult || []), ...(resp2.data.objectResult || [])],
      hasAct: !!resp2.data.objectResult,
    })),
  );
};
